
<template>
    <div style="margin-left:50px;">
  
      <el-form style="display: flex;flex-wrap: wrap;">
  
          <el-form-item label="答题人姓名:" style="display: flex;width: 33%;">
              <el-select
                  placeholder="请选择答题人姓名"
                  v-model="student"
                  style="width: 100%"
                  clearable
                  filterable>
                  <el-option
                  v-for="item in getStudentsArr"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
  
          <el-form-item label="问卷标题:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择问卷标题"
                  v-model="student_s"
                  style="width: 100%"
                  clearable
                  filterable>
                  <el-option
                  v-for="item in getStudentsArr_s"
                  :key="item.questionnaireId"
                  :value="item.questionnaireId"
                  :label="item.questionnaireTitle"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
  
          <el-form-item label="创建人:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择创建人"
                  v-model="coursecancellationStatusInput"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatus"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
  
  
          <el-form-item label="日期:" style="display: flex;width: 33%;"  label-width="75px">
              <el-date-picker
              style="width: 104%;margin-left: -139px;"
              v-model="dateTimeList"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable>
              </el-date-picker>
          </el-form-item>
  
          <el-form-item label="完成状态:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择完成状态"
                  v-model="coursecancellationStatusInput_s"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatuss"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
  
          <el-form-item label="分数:" style="display: flex;width: 33%;" >
              <!-- <el-select
                  placeholder="请选择分数"
                  v-model="coursecancellationStatusInput_ss"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatus"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select> -->
              <el-input v-model="coursecancellationStatusInput_ss" placeholder="请输入分数"></el-input>
          </el-form-item>
  
          
          <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
               <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="AddexportBtns">添加问卷</el-button> -->
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
          </div>
  
      </el-form>
  
  
      <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
          <!-- <el-table-column prop="courseDate" label="日期">
            <template slot-scope="scope">
               <span>{{scope.row.courseDate.substring(0,10)}}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="answerName" label="答题人姓名"></el-table-column>
          <el-table-column prop="creatorName" label="创建人"></el-table-column>
          <el-table-column prop="questionnaireTitle" label="问卷标题"></el-table-column>
          <el-table-column prop="createTime" label="日期"></el-table-column>
          <el-table-column prop="completeStatus" label="完成状态">
            <template slot-scope="scope">
                <div v-if="scope.row.completeStatus === 0">未完成</div>
                <div v-if="scope.row.completeStatus === 1">已完成</div>
              </template>
          </el-table-column>
          <el-table-column prop="totalScore" label="分数"></el-table-column>
          <el-table-column label="操作">
              <template slot-scope="scope">
                <div style="display: flex;justify-content: space-around;">
                  <el-button type="text" style="color:#00aaff;" @click="handleClickView('编辑', scope.row)">编辑</el-button>
                  <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">详情</el-button>
                </div>
              </template>
          </el-table-column>
        </el-table>
  
  
  
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
        layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
      </el-pagination>
  
  
  
      <el-dialog :title="ShowDlongTitle"  width="80%"  :visible.sync="ShowDlong" :before-close="commitCler">
<!--           
          <el-form ref="form" :model="form" label-width="80px">
  
              <el-form-item label="方案内容:" style="text-align: start;">
                  <div style="text-align: start;">{{form.student}}</div>
              </el-form-item>
              <el-divider></el-divider>
  
              <el-form-item label="提交人:" style="text-align: start;">
                 <div style="text-align: start;">{{form.student_s}}</div>
              </el-form-item>
              <el-divider></el-divider>
  
             <el-form-item label="相关资料:" style="text-align: start;">
              <div style="text-align: start;height: 47px; overflow-x: auto;">
                  <a style="margin-right: 10px;" v-for="(itme,index) in form.coursecancellationStatusInput" :key="index" :href="itme.url">{{ itme.name }}</a>
              </div>
             </el-form-item>
             <el-divider></el-divider>
  
             <el-form-item label="提交日期:" style="text-align: start;">
                 <div style="text-align: start;">{{form.dateTimeList}}</div>
             </el-form-item>
             <el-divider></el-divider>
  
  
          </el-form> -->


          <div style="text-align: center;font-size: 25px;font-weight: 900;">{{ examPaper.subjectName }}</div>
          
          <div v-if="ShowDlongTitle === '问卷详情'" style="text-align: end;font-size: 20px;font-weight: 400;">总分数：{{ examPaper.totaScore }}</div>


          <div style="margin-top: 30px;" v-for="(itme,index) in multipleChoiceQuestion" :key="index">
            <div style="display: flex;padding-left: 50px;">
                <div>单选题:</div>
                <div style="padding-left: 30px;">{{ index + 1 }}：{{ itme.titleTitle }}</div>
                <div style="padding-left: 10px;">({{ itme.titleScore }})</div>
            </div>

            <div style="text-align: start;padding-left: 120px;margin-top: 30px;">
                <el-button 
                    :disabled="true"
                    :class="ShowDlongTitle === '问卷详情' ? 'bomb' : '' "
                    v-for="(itmes,indexs) in itme.questionTypeSet" 
                    :key="indexs" 
                    :style="{ backgroundColor: itmes.COLOR ? itmes.COLOR : '' }"  
                    size="small"  
                    @click="handleSingleChoice(itmes,index,indexs)">
                    {{ itmes. key}}: {{ itmes. value}}
                </el-button>
            </div>

            <div style="text-align: start;padding-left: 120px;margin-top: 30px;">
                <div>答案解析:{{ itme.answer }}</div>
            </div>

          </div>


          <div style="margin-top: 30px;" v-for="(itme,index) in multipleChoiceQuestions" :key=" index + 'index' ">
            <div style="display: flex;padding-left: 50px;">
                <div>多选题:</div>
                <div style="padding-left: 30px;">{{ index + 1 }}：{{ itme.titleTitle }}</div>
                <div style="padding-left: 10px;">({{ itme.titleScore }})</div>
            </div>

            <div style="text-align: start;padding-left: 120px;margin-top: 30px;">
                <el-button 
                   :disabled="true"
                   :class="ShowDlongTitle === '问卷详情' ? 'bomb' : '' "
                    v-for="(itmes,indexs) in itme.questionTypeSet" 
                   :key="indexs" 
                   :style="{ backgroundColor: itmes.COLOR ? itmes.COLOR : '' }"  
                   size="small"  
                   @click="handleSingleChoiceS(itmes,index,indexs)">
                   {{ itmes. key}}: {{ itmes. value}}
                </el-button>
            </div>

            <div style="text-align: start;padding-left: 120px;margin-top: 30px;">
                <div>答案解析:{{ itme.answer }}</div>
            </div>

          </div>

          
          <div style="margin-top: 30px;" v-for="(itme,index) in shortAnswerQuestions" :key=" index + 'id-index' ">
            <div style="display: flex;padding-left: 50px;">
                <div>简单题:</div>
                <div style="padding-left: 30px;">{{ index + 1 }}：{{ itme.titleTitle }}</div>
                <div style="padding-left: 10px;">({{ itme.titleScore }})</div>
            </div>

            <div style="text-align: start;padding-left: 120px;margin-top: 30px;">
                <el-input :disabled="true" :class="ShowDlongTitle === '问卷详情' ? 'bomb' : '' "  type="textarea"  :autosize="{ minRows: 6, maxRows: 6 }" placeholder="请输入内容"  v-model="itme.questionTypeSet"  maxlength="1500"  show-word-limit ></el-input>
            </div>
            <div style="padding-left: 120px;display: flex;margin-top: 15px;" v-if=" ShowDlongTitle !== '问卷详情' ">
                <div style="padding-top: 10px;margin-right: 10px;">需要人工判分:</div>
                <el-input  style="width: 150px;" maxlength="3"  placeholder="请输入分数"  v-model="itme.ArtificialFraction"></el-input>
            </div>
          </div>


          
  
          <div slot="footer" class="dialog-footer" style="display: flex;justify-content: end;">
            <!-- <div style="padding-left: 10px;display: flex;" v-if=" ShowDlongTitle !== '问卷详情' ">
                <div style="padding-top: 10px;margin-right: 10px;">需要人工判分:</div>
                <el-input style="width: 150px;" maxlength="3"  placeholder="请输入分数"  v-model="ArtificialFraction"></el-input>
            </div> -->
            <el-button style="height: 30px;margin-top: 6px;margin-left: 30px;"  size="small" class="btns" icon="el-icon-error" @click="commitCler">取消</el-button>
            <!-- <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="commitAdd('No')">驳回</el-button> -->
            <el-button v-if=" ShowDlongTitle !== '问卷详情' " style="height: 30px;margin-top: 6px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="commitAdd('Yes')">提交</el-button>
          </div>
  
      </el-dialog>
      
  
  
      <el-dialog title="添加培训任务" style="padding: 0px 10px;" :visible.sync="AddShowDlong" :before-close="AddcommitCler">
          
          <el-form ref="form" :model="form" label-width="100px">
  
              <el-form-item label="培训名称:">
                  <el-input placeholder="请选择培训名称" v-model="Addform.TrainName" style="width: 100%" clearable> 
                  </el-input>
              </el-form-item>
  
              <el-form-item label="任务创建人:">
                <el-select
                  placeholder="请选任务创建人"
                  v-model="Addform.CreatorName"
                  style="width: 100%"
                  clearable
                  filterable>
                  <el-option
                      v-for="item in getStudentsArr_s"
                      :key="item.id"
                      :value="item.id"
                      :label="item.realname">
                  </el-option>
              </el-select>
              </el-form-item>
  
             <el-form-item label="参加培训人:">
              <el-select
                  placeholder="请选择参加培训人"
                  v-model="Addform.TrainerName"
                  style="width: 100%"
                  clearable
                  filterable>
                   <el-option
                       v-for="item in coursecancellationStatus"
                       :key="item.id"
                       :value="item.id"
                       :label="item.realname" >
                   </el-option>
              </el-select>
             </el-form-item>
  
             <el-form-item label="培训内容:">
                  <div style="width: 100%;height: 250px;overflow-x: auto;display: flex;">
                      <el-radio  @click="clickitem(item.id)" border v-model="Addform.TrainingContent"
                           style="width: 130px; height: 100%;" v-for="(item, index) in planArr" :key="index" :label='item.id'>
                          <h3 style="margin-top: 0px;">{{ item.planName }}</h3>
                          <div style="text-align: left;"  v-for="(item1, index1) in item.planList" :key="index1">
                              <p>课节数:{{ item1.classNum }}</p>
                              <p style="margin-bottom: 20px;">课时单价:{{ item1.classPrice }}</p>
                          </div>
                      </el-radio>
                  </div>
             </el-form-item>
  
             <el-form-item label="资料上传:">
                  <el-upload
                      class="upload-demo"
                      drag
                      action="#"
                      :on-remove="handleRemove"
                      :beforeUpload="beforeUpload"
                      :http-request="handleUpload"
                      :on-error="handleError"
                      :auto-upload="true"
                      show-file-list
                      :file-list="fileDataList"
                      multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
             </el-form-item>   
  
             <el-form-item label="审批人:">
                  <el-select
                      placeholder="请选择审批人"
                      v-model="Addform.ApprovedName"
                      style="width: 100%"
                      clearable
                      filterable >
                      <el-option
                          v-for="item in coursecancellationStatus"
                          :key="item.id"
                          :value="item.id"
                          :label="item.realname" >
                      </el-option>
                  </el-select>
             </el-form-item>
  
  
          </el-form>
  
  
          <div slot="footer" class="dialog-footer">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="AddcommitCler">取消</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="AddcommitSub">保存</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddcommitAdd">提交</el-button>
          </div>
  
      </el-dialog>
  
  
  
      <el-dialog title="审批意见" style="padding: 0px 10px;" :visible.sync="ShowapprovalOpinions" :before-close="approvalOpinionsCler">
          <el-input :autosize="{  minRows: 6, maxRows: 6 }"  type="textarea"  placeholder="请输入驳回内容"  v-model="approvalOpinionstextarea" maxlength="200" show-word-limit></el-input>
      
          <div slot="footer" class="dialog-footer">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddapprovalOpinions">确定</el-button>
          </div>
  
      </el-dialog>
  
  
      <el-dialog title="审批意见" style="padding: 0px 10px;" width="30%" :visible.sync="ShowapprovalOpinions_Yes" :before-close="approvalOpinionsCler_Yes">
          
          <div style="">是否提交审批意见?</div>
  
          <div slot="footer" class="dialog-footer" style="text-align: center;">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="approvalOpinionsCler_Yes">取消</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddapprovalOpinions_Yes">确定</el-button>
          </div>
  
      </el-dialog>
  
      



      

      <div class="box"  v-if="AddexportBtnssShow">
        
        <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;">
            <div style="text-align: end; padding-right: 20px; padding-top: 10px; font-size: 26px;" @click="AddexportBtnssShowCler"><i class="el-icon-close"></i> </div>
            <div style="font-size:20px;font-weight: 900;margin-bottom: 10px;margin-bottom:20px;">考试信息</div>

            <el-row style="margin-bottom: 10px;">
                <el-col :span="6">
                    <div style="margin-left: -30px;">
                        <span>答题人:</span>
                        <span>{{adminName}}</span>
                    </div>
                </el-col>
                <!-- <el-col :span="6" style="display: flex;justify-content: space-evenly;" class="no-click">
                    <div style="display: flex;margin-top: -10px;">
                        <span style="padding-top: 10px;margin-left: -63px;margin-right: 8px;">答题次数:</span>
                        <span><el-input v-model="inputAnswering" maxlength="2" placeholder="请输入答题次数"></el-input></span>
                    </div>
                </el-col> -->
                <el-col :span="10">
                    <div style="display: flex;justify-content: start;margin-left: 43px;" class="no-click">
                        <div style="width:100px;">问卷标题:</div>
                        <div style="margin-left: 10px;margin-top: -8px;">
                            <el-input style="width:400px;" v-model="inputQuestionnaireTitle" placeholder="请输入问卷标题"></el-input>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>


        <div style="display: flex;margin-top: 10px;" >
            <!-- <div style="width:18%;height: 750px; border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px; margin-right: 10px; margin-left: 10px;">
                <div style="width: 100%;display: flex;flex-wrap: wrap;">
                    <div class="actdiv" style="width: 50%;margin-top: 10px;"  @click="handleAddAnswers">多项填空</div>
                </div>
            </div> -->
            <div style="width:98%;height: 850px;border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;overflow: auto;margin-left: 10px;">

                <el-card style="height: 500px;width: 95%;border-radius: 20px;margin-left: 23px;margin-top: 10px;margin-right: 12px;" v-for="(itme,index) in completionList" :key="index">
                    <div style="margin-left:20px;">
                        <div style="font-size: 26px;padding-top: 1px; text-align: end; width: 100%;">
                            <!-- <i class="el-icon-remove-outline" @click="handleFreeformQuestionsReduce(index,'completionList')"></i> -->
                        </div>
                    </div>  
                    <div style="display: flex;margin-left: 40px;margin-top: 30px;height: 160px;" class="no-click">
                        <div style="width: 90%;display: flex;flex-wrap: wrap;height: 150px;">
                            <div style="display: flex;margin-bottom: 14px;width: 98%;">
                                <div style="display: flex;width: 100%;margin-left: 15px;">
                                    <div style="width: 100%;">
                                        <el-input resize="none" style="width: 100%;" type="textarea" :autosize="{ minRows: 9, maxRows: 9 }" 
                                        maxlength="1000" show-word-limit v-model="itme.questionTitle" placeholder="请输入多项填空"></el-input> 
                                        <div style="display: flex;"  v-if="ShowDlongTitle !== '方案名称详情'">
                                            <!-- <div style="margin-top: 10px;width: 77px;background-color:#428BCA;color: #fff;padding: 5px;border-radius: 5px;line-height: 29px;" @click="handleAddAnswer(index)">新增答案</div> -->
                                            <!-- <div style="margin-top: 10px;width: 77px;background-color:#428BCA;color: #fff;padding: 5px;border-radius: 5px;line-height: 29px; margin-left: 10px;" @click="handleAddAnswer(index,'删除')">删除答案</div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   <div style="display: flex;margin-top: 100px; height: 150px; overflow: auto;margin-left: 55px;">
                        
                        <div style="width:50%;">

                            <div style="display: flex; width: 100%;"  v-for="(itmes,indexs) in itme.answer" :key="indexs">
                            <!-- <div style="margin-left: 10px;margin-top: 10px;">
                                <el-input v-model="itmes.vacancyAnswer"  style="width: 255px;" placeholder="请输入填空答案"></el-input>
                            </div> 
                            <div style="margin-left: 10px;margin-top: 10px;">
                                <el-input v-model="itmes.vacancyScore" :maxlength="3" style="width: 120px;" placeholder="请输入分值"></el-input>
                            </div>  -->

                                <div style="margin-bottom: 10px;display: flex;height: 40px;">
                                    <div>正确答案：（第{{ indexs + 1 }}题）</div>
                                    <div style="margin-left: 20px; color: red;">{{ itmes.vacancyAnswer }}</div>
                                    <div style="margin-left: 20px;">分值：（{{itmes.vacancyScore}}）</div>
                                    
                                </div>

                            </div>

                        </div>


                        <div style="width:50%;">

                            <div style="display: flex; width: 100%;"  v-for="(itmes,indexss) in itme.questionResultAnswer" :key="indexss">

                                <div style="margin-bottom: 10px; display: flex;height: 40px;">
                                    <div style="margin-top: 11px;">用户输入的答案：（第{{ indexss + 1 }}题）</div>
                                    <div style="margin-left: 20px; color: red;margin-top: 11px;">答案：{{ itmes.vacancyAnswer }}</div>
                                    <div style="margin-left: 10px;height: 40px;">
                                      总分：  <el-input v-model="itmes.vacancyScore" :maxlength="3" style="width: 110px;;height: 20px !important;" placeholder="请输入分值"></el-input>
                                    </div> 
                                </div>

                            </div> 

                        </div>   



                   </div>
                </el-card>

            </div>
        </div>

        <div slot="footer" class="dialog-footer" style="position: fixed;bottom: 35px;right: 25px;">
            <el-button style="height: 30px;margin-top: 6px;margin-left: 30px;"  size="small" class="btns" icon="el-icon-error" @click="commitCler">取消</el-button>
            <el-button v-if=" ShowDlongTitle !== '问卷详情' " style="height: 30px;margin-top: 6px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="commitAdds('Yes')">提交</el-button>
          <!-- <el-button v-if="ShowDlongTitle !== '方案名称详情'" style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="AddexportBtnssShowAdd">提交</el-button> -->
        </div>

      </div>


  
  
  
  
  </div>
</template>
  
<script>
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import Vue from 'vue';
  import { ref, reactive, onMounted, defineComponent, toRefs, nextTick, onUpdated, watchEffect } from '@vue/composition-api'
  var $Vue = Vue.prototype
  import {  getStudentsType } from "@/api/fiveClassApi"
  import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
  import loadingUtils from "../utils/loading";
  import { isReturn } from "../utils/retnue";
  import { getTeachers } from "@/api/feedBackApi";
  export default defineComponent({
  
      setup(props, { attrs, slots, emit, expose }){
          let ArtificialFraction = ref('')
          let AddexportBtnssShow = ref(false)
          let approvalOpinionstextarea = ref('')
          let ShowapprovalOpinions = ref(false)
          let getStudentsArr = ref([])
          let getStudentsArr_s = ref([])
          let coursecancellationStatus = ref([])
          let student = ref('')
          let student_s = ref('')
          let coursecancellationStatusInput = ref('')
          let coursecancellationStatusInput_s = ref('')
          let coursecancellationStatusInput_ss = ref('')
          let dateTimeList = ref([])
          let dataList = ref([])
          let requestParameters = reactive({pageSize:10,total:0,pageNum:1})
          let ShowDlong = ref(false)
          let ShowDlongDisabled = ref(false)
          let ShowDlongTitle = ref('编辑')
          let form = reactive({ student:'', student_s: '', coursecancellationStatusInput:[], dateTimeList: '' })
          let AddShowDlong = ref(false)
          let Addform = reactive({ TrainName:'', CreatorName:'', TrainerName: '', TrainingContent:'', DataUpload: '', ApprovedName: '' })
          let planArr = ref([])
          let fileDataList = ref([])
          let ShowapprovalOpinions_Yes = ref(false)
          let coursecancellationStatuss = ref([])
          let examPaper = reactive({ subjectName:'', totaScore:0 })
          let dataRes = reactive({})
          let completionList  = ref([])
          let multipleChoiceQuestion = ref([ ])
          let multipleChoiceQuestions = ref([])
          let shortAnswerQuestions = ref([])
          let adminName = ref('')
          let inputAnswering = ref('')
          let inputQuestionnaireTitle = ref('')

          onMounted(()=>{
              handleAllApi()
              let admin = JSON.parse(localStorage.getItem('admin'))
              adminName.value = admin.realname
          })
  
          watchEffect(() => {
              console.log(`Count is now 让子弹飞一会`);
          })


          const AddexportBtnssShowCler = () =>{
               AddexportBtnssShow.value = false
          }
  
  
          const handleAllApi = () =>{
              getStudentsArr.value = [{ id: 1, realname : '李四' },{ id: 2, realname : '张三' },{ id: 3, realname : '王五' }]
              getStudentsArr_s.value = [{ id: 1, realname : '颇多野' },{ id: 2, realname : '梅川合' },{ id: 3, realname : '拖一大' }]
              coursecancellationStatus.value = [{ id: 1, realname : '唱' },{ id: 2, realname : '跳' },{ id: 3, realname : 'rap' }]
              dataList.value = [{ courseDate: '2024-01-14', courseStartTime: '张三', courseEndTime: '颇多野', subjectName: [{url:'https:baidu.com',name:'虚拟图片'},{url:'https:baidu.com',name:'虚拟图片2'}]  }]
              coursecancellationStatuss.value = [{ id: 0, realname : '未完成' },{ id: 1, realname : '已完成' }]

              axios.get(`${apiBaseUrl}/questionnaire/queryCreator`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
                }).then(res => {
                    isReturn(res.code)
                    coursecancellationStatus.value = res.data.data
                }).catch(error => {
                    console.error(error)
              })

              axios.get(`${apiBaseUrl}/questionnaire/queryTitle`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
                }).then(res => {
                    isReturn(res.code)
                    getStudentsArr_s.value = res.data.data
                }).catch(error => {
                    console.error(error)
              })

              getTeachers().then((res) => {
                   getStudentsArr.value= res.data
              })

              axios.post(`${apiBaseUrl}/contract/getList`, requestParameters,{
                  headers:{
                      'authorization': sessionStorage.getItem('tokenInfo')
                  },
              }).then(res => {
                  isReturn(res.code)
                  planArr.value = res.data.data.records
              }).catch(error => {
                  console.error(error)
              })


              let data = {
                    pageNo: requestParameters.pageNum,
                    pageSize: requestParameters.pageSize,
                    answerId: student.value,
                    questionnaireId : student_s.value,
                    creatorId : coursecancellationStatusInput.value,
                    startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                    endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
                    completeStatus : coursecancellationStatusInput_s.value,
                    totalScore : coursecancellationStatusInput_ss.value,
              }
              axios.post(`${apiBaseUrl}/answer/queryAnswerList`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  if(res.data){
                    dataList.value = res.data.data.list ? res.data.data.list : []
                    requestParameters.pageNum = res.data.data.pageIndex
                    requestParameters.total = res.data.data.allTotal
                  }else{
                    dataList.value =  []
                    requestParameters.pageNum = 1
                    requestParameters.pageSize = 10
                    requestParameters.total = 0
                  }
              }).catch(error => {
                  console.error(error)
              })

          }
  
          const handleMessage = (message,type) =>{
               $Vue.$message({ message, type, duration: 500 });
          }
  
          const approvalOpinionsCler = ()=>{
              approvalOpinionstextarea.value = ''
              ShowapprovalOpinions.value = false
              ShowDlong.value = true
              let detailsInfo = JSON.parse(sessionStorage.getItem('detailsInfo'))
              if(detailsInfo){
                 form.student = detailsInfo.student
                 form.student_s = detailsInfo.student_s
                 form.coursecancellationStatusInput = detailsInfo.coursecancellationStatusInput
                 form.dateTimeList = detailsInfo.dateTimeList
              }
          }
  
          const exportBtns = () =>{
            let data = {
                    answerId: student.value,
                    questionnaireId : student_s.value,
                    creatorId : coursecancellationStatusInput.value,
                    startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                    endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
                    completeStatus : coursecancellationStatusInput_s.value,
                    totalScore : coursecancellationStatusInput_ss.value,
            }
            axios.post(`${apiBaseUrl}/answer/excelAnswerList`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
                if(response.status == 200){
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
                    const downloadLink = document.createElement("a");
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = "结果查询.xlsx"; 
                    downloadLink.click();
                    handleMessage('导出成功', 'success')
                }
                else{
                    handleMessage('导出失败', 'error')
                }
            })
          }
          const searchBtns = () =>{
            let data = {
                    pageNo: requestParameters.pageNum ? requestParameters.pageNum : 1,
                    pageSize: requestParameters.pageSize,
                    answerId: student.value,
                    questionnaireId : student_s.value,
                    creatorId : coursecancellationStatusInput.value,
                    startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                    endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
                    completeStatus : coursecancellationStatusInput_s.value,
                    totalScore : coursecancellationStatusInput_ss.value,
              }
              axios.post(`${apiBaseUrl}/answer/queryAnswerList`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  if(res.data){
                    dataList.value = res.data.data.list ? res.data.data.list : []
                    dataList.value = res.data.data.list ? res.data.data.list : []
                    requestParameters.pageNum = res.data.data.pageIndex ? res.data.data.pageIndex : 1
                    requestParameters.total = res.data.data.allTotal
                  }else{
                    dataList.value =  []
                    requestParameters.pageNum = 1
                    requestParameters.pageSize = 10
                    requestParameters.total = 0
                  }
              }).catch(error => {
                  console.error(error)
              })
          }
          const clearBtns = () =>{
              student.value = ""
              student_s.value = ""
              coursecancellationStatusInput.value = ""
              coursecancellationStatusInput_s.value = ""
              coursecancellationStatusInput_ss.value = ""
              dateTimeList.value = []

              let data = {
                    pageNo: requestParameters.pageNum,
                    pageSize: requestParameters.pageSize,
                    answerId: student.value,
                    questionnaireId : student_s.value,
                    creatorId : coursecancellationStatusInput.value,
                    startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                    endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
                    completeStatus : coursecancellationStatusInput_s.value,
                    totalScore : coursecancellationStatusInput_ss.value,
              }
              axios.post(`${apiBaseUrl}/answer/queryAnswerList`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  if(res.data){
                    dataList.value = res.data.data.list ? res.data.data.list : []
                    dataList.value = res.data.data.list ? res.data.data.list : []
                    requestParameters.pageNum = res.data.data.pageIndex
                    requestParameters.total = res.data.data.allTotal
                  }else{
                    dataList.value =  []
                    requestParameters.pageNum = 1
                    requestParameters.pageSize = 10
                    requestParameters.total = 0
                  }
              }).catch(error => {
                  console.error(error)
              })

          }
          const addBtns = () =>{
              AddShowDlong.value = true
          }
  
          const handleSizeChange = (size) =>{
              requestParameters.pageSize = size
              let data = {
                    pageNo: requestParameters.pageNum,
                    pageSize: requestParameters.pageSize,
                    answerId: student.value,
                    questionnaireId : student_s.value,
                    creatorId : coursecancellationStatusInput.value,
                    startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                    endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
                    completeStatus : coursecancellationStatusInput_s.value,
                    totalScore : coursecancellationStatusInput_ss.value,
              }
              axios.post(`${apiBaseUrl}/answer/queryAnswerList`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  if(res.data){
                    dataList.value = res.data.data.list ? res.data.data.list : []
                    requestParameters.pageNum = res.data.data.pageIndex
                    requestParameters.total = res.data.data.allTotal
                  }else{
                    dataList.value =  []
                    requestParameters.pageNum = 1
                    requestParameters.pageSize = 10
                    requestParameters.total = 0
                  }
              }).catch(error => {
                  console.error(error)
              })
          }
          const handleCurrentChange = (page) =>{
              requestParameters.pageNum = page
              let data = {
                    pageNo: requestParameters.pageNum,
                    pageSize: requestParameters.pageSize,
                    answerId: student.value,
                    questionnaireId : student_s.value,
                    creatorId : coursecancellationStatusInput.value,
                    startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                    endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
                    completeStatus : coursecancellationStatusInput_s.value,
                    totalScore : coursecancellationStatusInput_ss.value,
              }
              axios.post(`${apiBaseUrl}/answer/queryAnswerList`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  if(res.data){
                    dataList.value = res.data.data.list ? res.data.data.list : []
                    requestParameters.pageNum = res.data.data.pageIndex
                    requestParameters.total = res.data.data.allTotal
                  }else{
                    dataList.value =  []
                    requestParameters.pageNum = 1
                    requestParameters.pageSize = 10
                    requestParameters.total = 0
                  }
              }).catch(error => {
                  console.error(error)
              })
          }
  
          const handleClickView = (boom, edible)=>{
              let { courseDate, courseEndTime, courseStartTime, subjectName, id } = edible
              form.student = courseStartTime
              form.student_s = courseEndTime
              form.coursecancellationStatusInput = subjectName
              form.dateTimeList = courseDate
              sessionStorage.setItem('detailsInfo',JSON.stringify(form))


              if(boom === '编辑'){
                if(edible.isVacancy){
                    AddexportBtnssShow.value = true
                    axios.get(`${apiBaseUrl}/answer/queryAnswerResultsInfo?id=${id}`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                        let data = res.data.data
                        dataRes = data
                        if(res.data.code == 200){
                            inputQuestionnaireTitle.value = data.questionnaireTitle
                            adminName.value = data.answerName
                            if(data.resultDetailsList){
                                if(data.resultDetailsList.fillInTheBlankList){
                                    data.resultDetailsList.fillInTheBlankList.forEach((itme)=>{
                                        itme.answer = JSON.parse(itme.answer)
                                        itme.questionResultAnswer = JSON.parse(itme.questionResultAnswer)
                                    })
                                }
                                completionList.value = data.resultDetailsList.fillInTheBlankList
                            }
                        }else{
                            handleMessage("错误信息", 'error')
                        }

                    })

                }else{
                  ShowDlong.value = true
                  ShowDlongDisabled.value = false
                  ShowDlongTitle.value = '编辑问卷'

                    axios.get(`${apiBaseUrl}/answer/queryAnswerResultsInfo?id=${id}`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                      let data = res.data.data
                      dataRes = data
                      
                      examPaper.totaScore = dataRes.totalScore
                      examPaper.subjectName = dataRes.questionnaireTitle

                      dataRes.resultDetailsList.singleChoiceList.forEach((itme)=>{
                            itme.titleTitle = itme.questionTitle
                            itme.titleScore = itme.score
                            itme.questionContent = JSON.parse(itme.questionContent)
                            itme.questionTypeSet = []
                            itme.questionContent.map((itmes)=>{
                                let node = {}
                                node.key = itmes.inputOption
                                node.value = itmes.inputValue
                                if(itme.answer){
                                    if(itme.answer === itmes.inputOption){
                                        node.COLOR = '#ecd78b'
                                    }else{
                                        node.COLOR = ''
                                    }
                                }else{
                                    node.COLOR = ''
                                }
                                itme.questionTypeSet.push(node)
                            })
                      })

                      dataRes.resultDetailsList.multipleChoiceList.forEach((itme)=>{
                            itme.titleTitle = itme.questionTitle
                            itme.titleScore = itme.score
                            itme.questionContent = JSON.parse(itme.questionContent)
                            itme.questionTypeSet = []
                            itme.questionContent.map((itmes)=>{
                                let node = {}
                                node.key = itmes.inputOption
                                node.value = itmes.inputValue
                                if(itme.answer){
                                    if(itme.answer.includes(itmes.inputOption)){
                                        node.COLOR = '#ecd78b'
                                    }else{
                                        node.COLOR = ''
                                    }
                                }else{
                                    node.COLOR = ''
                                }
                                itme.questionTypeSet.push(node)
                            })
                      })

                      dataRes.resultDetailsList.shortAnswerList.forEach((itme)=>{
                            itme.titleTitle = itme.questionTitle
                            itme.titleScore = itme.score
                            itme.questionContent = JSON.parse(itme.questionContent)
                            itme.questionContent.map((itmes)=>{
                                itme.questionTypeSet = itmes.inputValue
                            })
                      })


                      multipleChoiceQuestion.value = dataRes.resultDetailsList.singleChoiceList
                      multipleChoiceQuestions.value = dataRes.resultDetailsList.multipleChoiceList
                      shortAnswerQuestions.value = dataRes.resultDetailsList.shortAnswerList



                  }).catch(error => {
                      console.error(error)
                  }) 
                }
              }
              if(boom === '详情'){
                 if(edible.isVacancy){
                     AddexportBtnssShow.value = true
                     axios.get(`${apiBaseUrl}/answer/queryAnswerResultsInfo?id=${id}`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                        let data = res.data.data
                        dataRes = data
                        if(res.data.code == 200){
                            inputQuestionnaireTitle.value = data.questionnaireTitle
                            adminName.value = data.answerName
                            if(data.resultDetailsList){
                                if(data.resultDetailsList.fillInTheBlankList){
                                    data.resultDetailsList.fillInTheBlankList.forEach((itme)=>{
                                        itme.answer = JSON.parse(itme.answer)
                                        itme.questionResultAnswer = JSON.parse(itme.questionResultAnswer)
                                    })
                                }
                                completionList.value = data.resultDetailsList.fillInTheBlankList
                            }
                        }else{
                            handleMessage("错误信息", 'error')
                        }

                    })
                 }else{

                   ShowDlong.value = true
                   ShowDlongDisabled.value = true
                   ShowDlongTitle.value = '问卷详情'

                   axios.get(`${apiBaseUrl}/answer/queryAnswerResultsInfo?id=${id}`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                        let data = res.data.data
                        dataRes = data
                        
                        examPaper.totaScore = dataRes.totalScore
                        examPaper.subjectName = dataRes.questionnaireTitle

                        dataRes.resultDetailsList.singleChoiceList.forEach((itme)=>{
                                itme.titleTitle = itme.questionTitle
                                itme.titleScore = itme.score
                                itme.questionContent = JSON.parse(itme.questionContent)
                                itme.questionTypeSet = []
                                itme.questionContent.map((itmes)=>{
                                    let node = {}
                                    node.key = itmes.inputOption
                                    node.value = itmes.inputValue
                                    if(itme.answer){
                                        if(itme.answer === itmes.inputOption){
                                            node.COLOR = '#ecd78b'
                                        }else{
                                            node.COLOR = ''
                                        }
                                    }else{
                                        node.COLOR = ''
                                    }
                                    itme.questionTypeSet.push(node)
                                })
                        })

                        dataRes.resultDetailsList.multipleChoiceList.forEach((itme)=>{
                                itme.titleTitle = itme.questionTitle
                                itme.titleScore = itme.score
                                itme.questionContent = JSON.parse(itme.questionContent)
                                itme.questionTypeSet = []
                                itme.questionContent.map((itmes)=>{
                                    let node = {}
                                    node.key = itmes.inputOption
                                    node.value = itmes.inputValue
                                    if(itme.answer){
                                        if(itme.answer.includes(itmes.inputOption)){
                                            node.COLOR = '#ecd78b'
                                        }else{
                                            node.COLOR = ''
                                        }
                                    }else{
                                        node.COLOR = ''
                                    }
                                    itme.questionTypeSet.push(node)
                                })
                        })

                        dataRes.resultDetailsList.shortAnswerList.forEach((itme)=>{
                                itme.titleTitle = itme.questionTitle
                                itme.titleScore = itme.score
                                itme.questionContent = JSON.parse(itme.questionContent)
                                itme.questionContent.map((itmes)=>{
                                    itme.questionTypeSet = itmes.inputValue
                                })
                        })


                        multipleChoiceQuestion.value = dataRes.resultDetailsList.singleChoiceList
                        multipleChoiceQuestions.value = dataRes.resultDetailsList.multipleChoiceList
                        shortAnswerQuestions.value = dataRes.resultDetailsList.shortAnswerList



                    }).catch(error => {
                        console.error(error)
                    }) 
                   
                 }  
              }
          }
  
  
          const commitCler = () =>{
              AddexportBtnssShow.value = false
              completionList.value = []
              ArtificialFraction.value = ''
              ShowDlong.value = false
              sessionStorage.setItem('detailsInfo',JSON.stringify(null))
              handleClrAll()
          }
  
          const commitAdd = (boomm) =>{
              if(boomm === 'No'){
                  ShowapprovalOpinions.value = true
              }
              if(boomm === 'Yes'){
                 handleApiSubmit()
              }
              ShowDlong.value = false
              handleClrAll()
          }


          const commitAdds = () =>{


                dataRes.resultDetailsList = [...completionList.value]

                dataRes.resultDetailsList.forEach((itme)=>{
                    itme.answerScore = 0
                    itme.questionResultAnswer.map((itmes)=>{
                        console.log(Number(itmes.vacancyScore))
                        let s = Number(itmes.vacancyScore)
                        itme.answerScore += s
                    })
                    let JSONnew = itme.questionResultAnswer
                    itme.questionResult =  JSON.stringify(JSONnew)
                })

                let data = dataRes

                axios.post(`${apiBaseUrl}/details/updateResultsDetails`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {

                    if(res.data.code == 1 || res.code == 1){
                        handleMessage('更新答题失败', 'error')
                    }

                    if(res.data.code == 200){
                        handleMessage("添加成功", 'success')
                        AddexportBtnssShow.value = false
                        completionList.value = []
                        let data = {
                                pageNo: requestParameters.pageNum,
                                pageSize: requestParameters.pageSize,
                                answerId: student.value,
                                questionnaireId : student_s.value,
                                creatorId : coursecancellationStatusInput.value,
                                startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                                endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
                                completeStatus : coursecancellationStatusInput_s.value,
                                totalScore : coursecancellationStatusInput_ss.value,
                        }
                        axios.post(`${apiBaseUrl}/answer/queryAnswerList`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                            isReturn(res.code)
                            if(res.data.code == 200){
                                handleMessage("查询成功", 'success')
                            }
                            if(res.data){
                                dataList.value = res.data.data.list ? res.data.data.list : []
                                requestParameters.pageNum = res.data.data.pageIndex
                                requestParameters.total = res.data.data.allTotal
                            }else{
                                dataList.value =  []
                                requestParameters.pageNum = 1
                                requestParameters.pageSize = 10
                                requestParameters.total = 0
                            }
                        }).catch(error => {
                            console.error(error)
                        })


                        return true
                    }else{
                        return false
                    }
                }).catch(error => {
                    console.error(error)
                    return false
                })
          }


          const handleApiSubmit = () => {

                multipleChoiceQuestion.value.forEach((itme)=>{
                    itme.answerScore = itme.score
                })

                multipleChoiceQuestions.value.forEach((itme)=>{
                    itme.answerScore = itme.score
                })

                shortAnswerQuestions.value.forEach((itme)=>{
                    itme.answerScore = itme.ArtificialFraction
                })

                dataRes.resultDetailsList = [...multipleChoiceQuestion.value,...multipleChoiceQuestions.value,...shortAnswerQuestions.value]
                let data = dataRes

                axios.post(`${apiBaseUrl}/details/updateResultsDetails`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                    if(res.data.code == 200){
                        handleMessage("添加成功", 'success')
                        
                        let data = {
                                pageNo: requestParameters.pageNum,
                                pageSize: requestParameters.pageSize,
                                answerId: student.value,
                                questionnaireId : student_s.value,
                                creatorId : coursecancellationStatusInput.value,
                                startTime: `${dateTimeList.value[0] ? dateTimeList.value[0]: '' }`,
                                endTime:  `${dateTimeList.value[1] ? dateTimeList.value[1]: '' }`,
                                completeStatus : coursecancellationStatusInput_s.value,
                                totalScore : coursecancellationStatusInput_ss.value,
                        }
                        axios.post(`${apiBaseUrl}/answer/queryAnswerList`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                            isReturn(res.code)
                            if(res.data.code == 200){
                                handleMessage("查询成功", 'success')
                            }
                            if(res.data){
                                dataList.value = res.data.data.list ? res.data.data.list : []
                                requestParameters.pageNum = res.data.data.pageIndex
                                requestParameters.total = res.data.data.allTotal
                            }else{
                                dataList.value =  []
                                requestParameters.pageNum = 1
                                requestParameters.pageSize = 10
                                requestParameters.total = 0
                            }
                        }).catch(error => {
                            console.error(error)
                        })


                        return true
                    }else{
                        return false
                    }
                }).catch(error => {
                    console.error(error)
                    return false
                })
               
          }

  
          const handleClrAll = () =>{
              form.student = ""
              form.student_s = ""
              form.coursecancellationStatusInput = []
              form.dateTimeList = ""
          }
  
          const AddcommitCler = () =>{
              AddShowDlong.value = false
              handleClerAllDing()
          }
  
          const AddcommitAdd = () =>{
              console.log(Addform, 'Addform')
              console.log(fileDataList.value, 'fileDataList')
  
  
              AddShowDlong.value = false
              // setTimeout(()=>{
              //     handleClerAllDing()
              // },2000)
          }
          
          const AddexportBtns = () => {

          }

          const AddcommitSub = () =>{
              console.log(Addform, 'Addform')
              console.log(fileDataList.value, 'fileDataList')
  
  
              AddShowDlong.value = false
              // setTimeout(()=>{
              //     handleClerAllDing()
              // },2000)
          }
  
          const handleClerAllDing = () =>{
              fileDataList.value = []
              Addform.TrainName = ""
              Addform.CreatorName = ""
              Addform.TrainerName = ""
              Addform.TrainingContent = ""
              Addform.ApprovedName = ""
          }
  
          const clickitem = (itme) =>{
              console.log(itme, 'itme')
          }
  
          const handleRemove = (file, fileList) =>{
              fileDataList.value = fileList
          }
  
          const getFileName = (name) => {
               return name.substring(name.lastIndexOf("."))
          }
  
          const beforeUpload = (file, fileList) =>{
              loadingUtils.startLoading()
              const fileExtensions =
                  getFileName(file.name) === ".bmp" ||
                  getFileName(file.name) === ".tif" ||
                  getFileName(file.name) === ".gif" ||
                  getFileName(file.name) === ".pcx" ||
                  getFileName(file.name) === ".svg" ||
                  getFileName(file.name) === ".psd" ||
                  getFileName(file.name) === ".webp" ||
                  getFileName(file.name) === ".apng" ||
                  getFileName(file.name) === ".ai" ||
                  getFileName(file.name) === ".avif" ||
                  getFileName(file.name) === ".png" ||
                  getFileName(file.name) === ".pdf"||
                  getFileName(file.name) === ".mp4"||
                  getFileName(file.name) === ".excel"||
                  getFileName(file.name) === ".doc"||
                  getFileName(file.name) === ".ppt"||
                  getFileName(file.name) === ".mp3"||
                  getFileName(file.name) === ".xls"||
                  getFileName(file.name) === ".xlsx"||
                  getFileName(file.name) === ".pptx"||
                  getFileName(file.name) === ".docx"||
                  getFileName(file.name) === ".txt"||
                  getFileName(file.name) === ".jpg";
              const max20M = file.size / 1024 / 1024 < 1000;
  
              if (!fileExtensions) {
                  handleMessage("上传文件类不合格式!", 'warning')
              }
              if (!max20M) {
                  handleMessage("上传文件类不合格式!", 'warning')
              }
  
              return fileExtensions && max20M
          }
  
          const handleUpload = (option) =>{
              let obj = option.file.name
              let index = obj.lastIndexOf(".")
              obj = obj.substring(index, obj.length)
              let objName = getFileNameUUID() + getFileName(option.file.name)
              put(`mz_pc/${objName}`, option.file).then((res) => {
                  loadingUtils.endLoading()
                  signatureUrl(`mz_pc/${objName}`).then((res) => {})
              });
          }
  
          const handleError = () =>{
              loadingUtils.endLoading()
          }
  
  
          const AddapprovalOpinions = () =>{
              ShowapprovalOpinions.value = false
              approvalOpinionstextarea.value = ''
              handleMessage('提交了驳回','success')
          }
  
          const approvalOpinionsCler_Yes = () => {
              ShowapprovalOpinions_Yes.value = false
              ShowDlong.value = true
              let detailsInfo = JSON.parse(sessionStorage.getItem('detailsInfo'))
              if(detailsInfo){
                 form.student = detailsInfo.student
                 form.student_s = detailsInfo.student_s
                 form.coursecancellationStatusInput = detailsInfo.coursecancellationStatusInput
                 form.dateTimeList = detailsInfo.dateTimeList
              }
          }
  
          const AddapprovalOpinions_Yes = () => {
              ShowapprovalOpinions_Yes.value = false
              handleMessage('提交了通过','success')
          }


          const handleSingleChoice = (item,index,indexs) => {
                let COLOR =  '#ecd78b'
                
                if(item.COLOR === '#ecd78b'){
                    let newNode = { key: item.key, value: item.value, COLOR:'' }
                    multipleChoiceQuestion.value[index].questionTypeSet[indexs] = newNode
                    handleCler(index,multipleChoiceQuestion.value[index].questionTypeSet)
                }else{
                    handleCler(index,multipleChoiceQuestion.value[index].questionTypeSet)
                    let newNode = { key: item.key, value: item.value, COLOR }
                    multipleChoiceQuestion.value[index].questionTypeSet[indexs] = newNode
                }

          }

          const handleCler = (index,value) => {
            let list = []
            value.map((item)=>{
            let newNode = { key: item.key, value: item.value, COLOR: '' }
                  list.push(newNode)
            })
            multipleChoiceQuestion.value[index].questionTypeSet = list 
          }


          const handleSingleChoiceS = (item,index,indexs) => {
                let COLOR = '#ecd78b'

                if(item.COLOR === '#ecd78b'){
                    let newNode = { key: item.key, value: item.value, COLOR:'' }
                    multipleChoiceQuestions.value[index].questionTypeSet[indexs] = newNode
                    handleClerS(index,multipleChoiceQuestions.value[index].questionTypeSet)
                }else{
                    let newNode = { key: item.key, value: item.value, COLOR }
                    multipleChoiceQuestions.value[index].questionTypeSet[indexs] = newNode
                    handleClerS(index,multipleChoiceQuestions.value[index].questionTypeSet)
                }
          }

          const handleClerS = (index,value) => {
                let list = []
                value.map((item)=>{
                let newNode = { key: item.key, value: item.value, COLOR: item.COLOR }
                    list.push(newNode)
                })
                multipleChoiceQuestions.value[index].questionTypeSet = list 
          }

  
  
          return {
              AddexportBtnssShow,
              handleClerS,
              handleCler,
              handleUpload,
              beforeUpload,
              handleError,
              getFileName,
              handleRemove,
              handleClerAllDing,
              fileDataList,
              examPaper,
              clickitem,
              AddcommitCler,
              AddcommitAdd,
              commitCler,
              commitAdd,
              completionList,
              handleMessage,
              getStudentsArr,
              getStudentsArr_s,
              coursecancellationStatus,
              student,
              student_s,
              planArr,
              coursecancellationStatuss,
              coursecancellationStatusInput,
              coursecancellationStatusInput_s,
              coursecancellationStatusInput_ss,
              dateTimeList,
              handleAllApi,
              exportBtns,
              searchBtns,
              clearBtns,
              addBtns,
              handleSingleChoice,
              handleSingleChoiceS,
              dataList,
              adminName,
              handleClickView,
              handleSizeChange,
              handleCurrentChange,
              requestParameters,
              ShowDlongTitle,
              ShowDlong,
              form,
              AddexportBtnssShowCler,
              inputAnswering,
              inputQuestionnaireTitle,
              dataRes,
              ShowDlongDisabled,
              handleClrAll,
              AddcommitSub,
              AddShowDlong,
              Addform,
              ShowapprovalOpinions,
              approvalOpinionsCler,
              approvalOpinionstextarea,
              AddapprovalOpinions,
              ShowapprovalOpinions_Yes,
              approvalOpinionsCler_Yes,
              AddapprovalOpinions_Yes,
              AddexportBtns,
              multipleChoiceQuestion,
              multipleChoiceQuestions,
              shortAnswerQuestions,
              ArtificialFraction,
              commitAdds,
          }
  
      }
  
  })
  
  
</script>
  
<style scoped  lang="less">
   .box{
        position: fixed;
        background: #f3f3f3;
        width: 100%;
        z-index: 1111;
        top: 0;
        left: 0;
        height: 100vh;
        margin: 0;
    }
  
  .btns{
    background-color: #428BCA;
    border-color: #428BCA;
    color: #fff;
  }
  
  /deep/ .el-upload{
      width: 100% !important;
  }
  /deep/ .el-form-item__label{
      text-align: start;
  }
  /deep/ .el-textarea{
       width: 80%;
  }
  .bomb {
    pointer-events: none;
  }
  .no-click {
    pointer-events: none;
   }


</style>


// WEBPACK FOOTER //
// src/InitializationFile/resultQuery.vue